module.exports = __webpack_public_path__ + "img/GB10.81786c13.webp";